import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import isNil from 'lodash/isNil';

/**
 * A hook that provides safe access to a single LaunchDarkly flag by key.
 * Returns the flag value only when the LaunchDarkly client is available.
 *
 * This hook supports boolean flag (default) and other types possible on LaunchDarkly (string, number, json).
 */
export function useReadyFlag<T = boolean>(flagName: string): T | false {
  const flags = useFlags();
  const ldClient = useLDClient();
  const isReady: boolean = !isNil(ldClient);
  return isReady ? flags[flagName] : false;
}

export function useEnableBoreAndDamInPumpControl() {
  const enableBoreAsDestination = false; // Not implemented yet
  const enableDamAsDestination = useReadyFlag('enableDamAsPumpControlDestination');
  const enableBoreOrDamAsDestination = enableBoreAsDestination || enableDamAsDestination;

  const enableBoreAsSource = useReadyFlag('enableBoreAsPumpControlSource');
  const enableDamAsSource = useReadyFlag('enableDamAsPumpControlSource');
  const enableBoreOrDamAsSource = enableBoreAsSource || enableDamAsSource;

  const enableBoreOrDamAsConnection = enableBoreOrDamAsDestination || enableBoreOrDamAsSource;

  return {
    enableBoreAsDestination,
    enableDamAsDestination,
    enableBoreOrDamAsDestination,

    enableBoreAsSource,
    enableDamAsSource,
    enableBoreOrDamAsSource,

    enableBoreOrDamAsConnection
  };
}
